import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SelectMenu } from '@livable/saas-react-components';
import { Button, MenuItem, Typography } from '@mui/material';
import { toJS } from 'mobx';
export const ModalContent = observer(_ref => {
  let utility = _ref.utility,
    onSaveAndClose = _ref.onSaveAndClose,
    onSaveAndCloseCustom = _ref.onSaveAndCloseCustom,
    handleModalClose = _ref.handleModalClose,
    _ref$isPayable = _ref.isPayable,
    isPayable = _ref$isPayable === void 0 ? false : _ref$isPayable;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const effectiveUtilityId = (utility === null || utility === void 0 ? void 0 : utility.utilityId) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId);
  const pUtility = store.credentials.utilitiesGlSettings.find(i => i.utilityId === effectiveUtilityId);
  const savedValue = isPayable ? pUtility === null || pUtility === void 0 ? void 0 : pUtility.accountsPayableGlAccountExternalId : pUtility === null || pUtility === void 0 ? void 0 : pUtility.glAccountExternalId;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchKey = _useState2[0],
    setSearchKey = _useState2[1];
  const _useState3 = useState(savedValue ? savedValue : ''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  useEffect(() => {
    setValue(savedValue || '');
  }, [savedValue]);
  const utilityGlAccounts = searchKey.trim() ? store.credentials.glAccounts.filter(i => i.name.toLocaleLowerCase().includes(searchKey.trim().toLocaleLowerCase())) : store.credentials.glAccounts;
  const handleGlSearch = v => {
    setSearchKey(v);
  };
  const handleChange = data => {
    if (effectiveUtilityId) {
      store.credentials.setUtilitiesGlSettings(_objectSpread(_objectSpread({}, isPayable ? {
        accountsPayableGlAccountExternalId: data
      } : {
        glAccountExternalId: data
      }), {}, {
        utilityId: effectiveUtilityId,
        propertyUtilityLivableId: null
      }));
    }
    setSearchKey('');
    setValue(data);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, isPayable ? t('Accounts Payable GL Account (Expense)') : t('Resident Charges GL Account (Income)')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, isPayable ? t('Select the utility payable GL account.') : t('Select the utility GL account.')), /*#__PURE__*/React.createElement("div", {
    className: classes.glAccount
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: isPayable ? 'payable-gl-selector' : 'gl-selector',
    enableSearch: true,
    labelId: isPayable ? 'payable-gl-selector-label' : 'gl-selector-label',
    label: isPayable ? 'Select utility payable GL account' : 'Select utility GL account',
    disabled: store.credentials.glAccounts.length === 0,
    onSearch: handleGlSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => handleChange(e.target.value),
    value: value,
    renderValue: selected => {
      var _utilityGlAccounts$fi;
      if (selected.length === 0) {
        return '';
      }
      return (_utilityGlAccounts$fi = utilityGlAccounts.find(item => item.externalId === selected)) === null || _utilityGlAccounts$fi === void 0 ? void 0 : _utilityGlAccounts$fi.name;
    }
  }, utilityGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number)))))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rightButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      if (onSaveAndClose) {
        onSaveAndClose(_objectSpread({
          pUtility: toJS(pUtility),
          utility: toJS(utility),
          utilityGlAccounts: toJS(utilityGlAccounts)
        }, isPayable ? {
          accountsPayableGlAccountExternalId: value
        } : {
          glAccountExternalId: value
        }));
      }
      if (onSaveAndCloseCustom) onSaveAndCloseCustom(value);
      handleModalClose();
    },
    'custom-attribute': '168-gl-modal'
  }, t('add_new_property_flow.save_and_close')))));
});